import React, { memo, useEffect } from 'react';

import { LinkButton, useDeviceType, useUserBrowserTheme } from '@cian/ui-kit';
import { BorderBlock } from '../BorderBlock';
import { ETestIds } from '../../constants';
import { useTracking } from 'shared/mortgageMiniCalculator/utils/tracking/useTracking';

const imgPath = 'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_mini_calculator/eye-for-luope.svg';
const imgPathDark =
  'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_mini_calculator/eye-for-luope-inverted.svg';

const linkUrl = 'https://cian.ru/ipoteka/';

export const OfferEmpty: React.FC = memo(() => {
  const { trackShowEmptyListing, trackClickEmptyListingBtn } = useTracking();
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const theme = useUserBrowserTheme();

  useEffect(() => {
    trackShowEmptyListing();
  }, []);

  return (
    <BorderBlock
      testId={ETestIds.OffersEmpty}
      imgUrl={theme === 'dark' ? imgPathDark : imgPath}
      title={'Нет подходящих предложений'}
      description={'Попробуйте увеличить первый взнос или срок кредита'}
      button={
        <LinkButton theme="fill_secondary" fullWidth={isMobile} href={linkUrl} onClick={trackClickEmptyListingBtn}>
          Подбери свою ипотеку
        </LinkButton>
      }
    />
  );
});

OfferEmpty.displayName = 'OfferEmpty';
